// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"cadb2c23","137":"cadb2c23","142":"08c97514","202":"cadb2c23","248":"42af101c","314":"277440d7","646":"bf6961c2","727":"277440d7","877":"2ca2c156"}[chunkId] + ".chunk.css";
};